import React from "react";
import SimpleReactValidator from "simple-react-validator";
import Select from "react-select";
import { helperFunctions as HF } from "../../helper/helperFunctions";
import Address from "./Address";
import { customSelectStyles } from "./selectStyles";

class AddEditContactForm extends React.Component {
    constructor(props) {
        super(props);
        this.valitdatorList = new SimpleReactValidator();
        this.state = {
            ...this.props.addressPro,
            addressObject: this.props.addressObject,
            submitted: false,
            formType: this.props.formTypePro || "",
            selectedAddressType: this.props.addressPro.type_id || "",
            selectedAddressTypeName: ""
        };
        this.handleSubmitForm = this.handleSubmitForm.bind(this);
    }

    addressTypeChangeHandler = e => {
        this.setState({
            selectedAddressType: e.value,
            selectedAddressTypeName: e.label,
        }, () => {
            let obj = {
                type_id: this.state.selectedAddressType,
                type: this.state.selectedAddressTypeName,
            }
            this.props.addressTypeChangeHandlerProp(obj);
        });
    };

    openAddNewTagForm = (modelType, displayTitle, listTypeId) => {
        this.props.returnState({
            tagTypeAddModal: true,
            addNewModelType: modelType,
            addNewModelDisplayTitle: displayTitle,
            list_type_id: listTypeId
        });
    };

    handleSubmitForm(e) {
        e.preventDefault();
        if (this.valitdatorList.allValid()) {
            this.setState(
                {
                    submitted: true
                },
                function () {
                    this.props.handleFormSubmitProp(this.state.addressObject);
                }
            );
        } else {
            this.setState({ submitted: false });
            this.valitdatorList.showMessages();
            this.forceUpdate();
        }
    }

    getOptions() {
        if (this.props.addressTypes === undefined) {
            return [];
        }
        let returnObj = (id,title,disable) => {
            return {
                value: id,
                label: title,
                isDisabled: disable
            }
        }
        // if (window.location.href.includes('brand')) {
        //     return this.props.addressTypes.map(({id, title}) => {
        //         return returnObj(id,title,false);
        //     });
        // }
        console.log(' this.state.addressObject.address', this.props.addressTypes)
        return this.props.addressTypes.map(({id, title}) => {
            if ( this.state.addressObject.address && this.state.addressObject.address.type === 'primary') {
                return returnObj(id,title,true);
            } else {
                if (title === 'primary') {
                    return  returnObj(id,title,true);
                }
                return returnObj(id,title,false);
            }

        });
        // return this.props.addressTypes.map(({ id, title }) => ({
        //     value: id,
        //     label: title
        // }));
    }

    componentWillUnmount() {
        this.props.resetAfterUnmount();
    }

    render() {
        return (
            <form onSubmit={this.handleSubmitForm}>
                <Address
                    formTypePro={this.state.formType}
                    addressPro={this.props.addressPro}
                    addressObject={this.props.addressPro}
                    htmlElement={""}
                    shippingAddress={false}
                    options={{
                        countries: this.props.countries
                    }}
                    requiredField={{
                        country_id: "required",
                        line1: "required",
                        city: "required",
                        region_id: "required",
                        zip_post_code: ""
                            ? ["integer", "required"]
                            : ["integer"]
                    }}
                    countries={this.props.countries}
                    returnState={this.props.returnState}
                    validatorInstance={this.props.validatorProp}
                    openAddNewTagForm={this.openAddNewTagForm}
                    showTagTypeAddModal={this.props.showTagTypeAddModal}
                    refreshRegionsTime={this.state.refreshRegionsTime}
                />
                <div className="permissionList mt-xlg">
                    <Select
                        styles={customSelectStyles}
                        value={HF.returnLabelWithValue(
                            this.state.selectedAddressType,
                            this.getOptions()
                        )}
                        onChange={this.addressTypeChangeHandler}
                        options={this.getOptions()}
                        name={"type_id"}
                        placeholder={"Address Type"}
                        isClearable={false}
                    />
                    {this.props.validatorProp.message(
                        "Address Type",
                        this.state.selectedAddressType,
                        "required"
                    )}
                </div>

                <div className="row">
                    <div className="col-md-12 mb-xlg">
                        <div className="mt-xlg text-center">
                            <input
                                type="submit"
                                value="Submit"
                                className="customBtn btnBlue"
                            />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default AddEditContactForm;



// WEBPACK FOOTER //
// ./src/components/ThemeComponents/AddEditAddressForm.jsx